import React, { useState } from "react";
import { MapPin, Info, Image } from "react-feather";
import { useNavigate } from "react-router-dom";
import ImageModal from "../../common/FullScreenImageModal";
import styles from "./ArenaUserDashboard.module.css";

const ArenaGrid = ({ arenas, onArenaSelect, onViewDetails }) => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const renderLogo = (logo) => {
    if (logo) {
      if (logo.startsWith("data:image")) {
        return logo;
      }
      return `data:image/jpeg;base64,${logo}`;
    }
    return null;
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={i} className="fas fa-star text-yellow-400"></i>);
    }

    if (hasHalfStar) {
      stars.push(
        <i key="half" className="fas fa-star-half-alt text-yellow-400"></i>
      );
    }

    const emptyStars = 5 - Math.ceil(rating);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <i key={`empty-${i}`} className="far fa-star text-gray-300"></i>
      );
    }

    return stars;
  };

  const handleImageClick = (e, logo) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedImage(logo);
    setModalOpen(true);
  };

  const closeImageModal = () => {
    setModalOpen(false);
    setSelectedImage(null);
  };

  return (
    <div>
      <div className={styles.grid}>
        {arenas.length > 0 ? (
          arenas.map((arena) => (
            <div key={arena.id} className={styles.card}>
              <div className={styles.info}>
                <div>
                  <h3 className={styles.name}>
                    <div className={styles.cardImage}>
                      {renderLogo(arena.logo) ? (
                        <img
                          src={renderLogo(arena.logo)}
                          alt={arena.name}
                          className={styles.image}
                          onClick={(e) =>
                            handleImageClick(e, renderLogo(arena.logo))
                          }
                          style={{ cursor: "pointer", pointerEvents: "auto" }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://upload.wikimedia.org/wikipedia/commons/a/a3/Arena-bukareszt.jpg";
                          }}
                        />
                      ) : (
                        <div className={styles.placeholderImage}>
                          <Image size={48} />
                          <p>No image available</p>
                        </div>
                      )}
                    </div>
                    <div>
                      {arena.name}
                      <div style={{ flexDirection: "initial" }}>
                        {renderStars(parseFloat(arena.rating.average))}
                      </div>
                      <p className={styles.location}>
                        <MapPin size={12} />
                        {arena.location || arena.address}
                      </p>
                    </div>
                  </h3>
                </div>
                <div className={styles.about}>
                  <p>{arena.about_arena || "No description available"}</p>
                </div>
                <div className={styles.buttonGroup}>
                  <button
                    className={`${styles.button} ${styles.bookButton}`}
                    onClick={() => onArenaSelect(arena)}
                  >
                    Book Now
                  </button>
                  <button
                    className={`${styles.button} ${styles.detailsButton}`}
                    onClick={() => navigate(`/arena-details/${arena.id}`)}
                  >
                    <Info size={12} /> Details
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No Arenas Available</p>
        )}
      </div>

      {/* Image Modal */}
      <ImageModal
        images={selectedImage}
        isOpen={modalOpen}
        onClose={closeImageModal}
        alt="Arena Logo"
        isBase64={false}
      />
    </div>
  );
};

export default ArenaGrid;
